import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import { Row, Col, Spinner, Modal, ModalBody, Button, Input, Progress } from "reactstrap"
import { withRouter } from "react-router"
import { withTranslation } from "react-i18next"
import apis from "api"
import FileDownload from "js-file-download"

const DataTableAvisAbsenceValidation = props => {
  const lng = localStorage.getItem("I18N_LANGUAGE")
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  var user_id = userAuthScolarite.user.id
  const [loading, setLoading] = useState(false)
  const [modal, setModal] = useState(false)
  const [id, setId] = useState("")
  const [imp, setImp] = useState(0)
  const [view, setView] = useState(0)
  const [cloture, setCloture] = useState(0)
  const [modalAffiche, setModalAffiche] = useState(false)
  // Data Table
  const [avisAbsence, setAvisAbsence] = useState([])
  const [uploadPercent, setUploadPercent] = useState(0)
  const [modalDelete, setModalDelete] = useState(false)


  const pageOptions = {
    loading: true,
    hidePageListOnlyOnePage: true,
    totalSize: avisAbsence.length,
    page: 1,
    nextPageText: props.t("Suivant"),
    prePageText: props.t("Précedent"),
    alwaysShowAllBtns: true,
    sizePerPageList: [
      {
        text: "50",
        value: 50,
      },
      {
        text: "100",
        value: 100,
      },
      {
        text: "200",
        value: 200,
      },
      {
        text: "300",
        value: 300,
      },
      {
        text: "All",
        value: avisAbsence.length,
      },
    ],
  }

  const NoDataIndication = () => (
    <h6 style={{ textAlign: "center" }}>Aucun information à afficher</h6>
  )
  const Columns = () => [
    {
      dataField: "Semestre",
      text: props.t("Semestre"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "enseignant",
      text: props.t("Enseignant"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "date_debut",
      text: props.t("Date début"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "date_fin",
      text: props.t("Date fin"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "TypeAbsence",
      text: props.t("Type Absence"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "Notif",
      text: props.t("Notifier les étudiants"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) =>
        cloture !== 1 ? (
          row.etat === 1 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <i
                style={{
                  color: "rgba(0,250,147,0.44)",
                  cursor: "pointer",
                  fontSize: "20px",
                }}
                onClick={() => toggleAffiche(row)}
                className="bx bx-bell bx-tada"
                title={"Notifier les étudiants"}
              ></i>
            </div>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <i
                style={{
                  color: "#a7a3a3",
                  cursor: "pointer",
                  fontSize: "20px",
                }}
                title={
                  "En attendant la validation de l'absence et d'ajouter la justification"
                }
                className="bx bx-bell bx-tada"
              ></i>
            </div>
          )
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#a7a3a3", cursor: "pointer", fontSize: "20px" }}
              title="Année clôturée"
              className="bx bx-bell "
            ></i>
          </div>
        ),
    },
    {
      dataField: "justification",
      text: props.t("Télécharger justification"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) =>
        cloture !== 1 ? (
          row.justification !== null ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <i
                style={{ color: "#00afff", cursor: "pointer" }}
                onClick={() => download2(row)}
                className="fas fa-file-download"
              ></i>
            </div>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <i
                style={{ color: "#a7a3a3", cursor: "pointer" }}
                title={"Aucune Justification"}
                className="fas fa-file-download"
              ></i>
            </div>
          )
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#a7a3a3", cursor: "pointer" }}
              title="Année clôturée"
              className="fas fa-file-download"
            ></i>
          </div>
        ),
    },
    {
      dataField: "Impression avis d'abcense",
      isDummyField: true,
      text: "Avis d'absence d'un enseignant",
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) =>
        cloture !== 1 ? (
          imp === 1 ? (
            <a
              href={
                "https://flshs.scolarite.backcresus-institut.ovh/api/avis/absence/imp_avis_absence/" +
                row.id
              }
              target="_blank"
              rel="noreferrer"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <i
                style={{ color: "#0d7497", cursor: "pointer" }}
                // onClick={""}
                className="fas fa-file-download"
              ></i>
            </a>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <i
                style={{ color: "#a7a3a3", cursor: "pointer" }}
                className="fas fa-file-download"
              ></i>
            </div>
          )
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#a7a3a3", cursor: "pointer" }}
              className="fas fa-file-download"
              title="Année clôturée"
            ></i>
          </div>
        ),
    },
    {
      dataField: "Validation",
      isDummyField: true,
      text: props.t("Validation"),
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) =>
        cloture !== 1 ? (
          row.etat === 0 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <i
                style={{ color: "#ED6464", cursor: "pointer" }}
                onClick={() => toggle(row.id)}
                className="fas fa-cogs"
              ></i>
            </div>
          ) : row.etat === 1 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <i
                style={{ color: "#18ae3d", cursor: "pointer" }}
                className="fas fa-check"
                onClick={() => toggle(row.id)}
                title="Avis d'absence accepté"
              ></i>
            </div>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <i
                style={{ color: "#a13939", cursor: "pointer" }}
                className="fas fa-times"
                onClick={() => toggle(row.id)}
                title="Avis d'absence refusée"
              ></i>
            </div>
          )
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#a7a3a3", cursor: "pointer" }}
              className="fas fa-times"
              title="Année clôturée"
            ></i>
          </div>
        ),
    },
    {
      dataField: "Suppression",
      isDummyField: true,
      text: props.t("Suppression"),
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#ED6464", cursor: "pointer" }}
              onClick={() => toggleDeleteAvis(row)}
              className="fas fa-trash-alt"
            ></i>
          </div>
      )
    },
  ]
  const download2 = row => {
    apis
      .post(
        "avis/absence/download",
        {
          id: row.id,
          annee_id: annee_id,
        },
        { responseType: "blob" }
      )
      .then(res => {
        FileDownload(res.data, `${row.enseignant}.${row.extension}`)
      })
  }

  const { SearchBar } = Search

  useEffect(async () => {
    var cloture_annee = JSON.parse(localStorage.getItem("cloture"))
    setCloture(cloture_annee)
    const userAuth = JSON.parse(localStorage.getItem("UserMenu"))
    const typeArticleSubMenu = userAuth.find(user =>
      user.sous_menu.some(subMenu => subMenu.sous_menu === "Avis d'absence")
    )
    setImp(typeArticleSubMenu.sous_menu[0].imp)
    setView(typeArticleSubMenu.sous_menu[0].view)
    const res = await apis
      .post("avis/absence/listScolarite", { annee_id })
      .then(res => {
        setAvisAbsence(res.data.avis)
      })
    setLoading(true)
  }, [])

  const toggle = id => {
    setModal(!modal)
    setId(id)
  }
  const toggleAffiche = row => {
    setModalAffiche(!modalAffiche)
    setId(row.id)
  }
  const toggleDeleteAvis = row => {
    setModalDelete(!modalDelete)
    setId(row.id)
  }

  const toggleDelete = async () => {
    setModal(!modal)
    const res = await apis
      .post("avis/absence/valider", {
        id: id,
        etat: 1,
        annee_id,user_id
      })
      .then(res => {
        const resD = apis
          .post("avis/absence/listScolarite", { annee_id })
          .then(resD => {
            setAvisAbsence(resD.data.avis)
          })
        setLoading(true)
      })
  }
  const toggleNotifier = async () => {

    const options = {
      onUploadProgress: progressEvent => {
        const { loaded, total } = progressEvent
        let percent = Math.floor((loaded * 100) / total)
        console.log(`${loaded}kb of ${total}kb | ${percent}%`)
        if (percent < 100) {
          setUploadPercent(percent)
        }
      },
    }
    const res = await apis
      .post("avis/absence/send_mail_to_etudiant", {
        id: id,
        annee_id: annee_id,
        user_id
      },options)
      .then(res => {
        const resD = apis
          .post("avis/absence/listScolarite", { annee_id })
          .then(resD => {
            setAvisAbsence(resD.data.avis)
            setModalAffiche(!modalAffiche)
          })
        setLoading(true)
      })
  }
  const toggleRefus = async () => {
    setModal(!modal)
    const res = await apis
      .post("avis/absence/valider", {
        id: id,
        etat: 2,annee_id,user_id
      })
      .then(res => {
        const resD = apis
          .post("avis/absence/listScolarite", { annee_id })
          .then(resD => {
            setAvisAbsence(resD.data.avis)
          })
        setLoading(true)
      })
  }
  const toggleDeleteAvsAbsence = async () => {
    setModalDelete(!modalDelete)
    const res = await apis
      .post("avis/absence/delete_scolarite", {
        id: id,
        user_id,
        annee_id
      })
      .then(res => {
        const resD = apis
          .post("avis/absence/listScolarite", { annee_id })
          .then(resD => {
            setAvisAbsence(resD.data.avis)
          })
        setLoading(true)
      })
  }

  useEffect(() => {
    setModal(false)
  }, [avisAbsence])

  return (
    <React.Fragment>
      <div>
        {loading ? (
          <Row>
            <Col xs="12">
              <ToolkitProvider
                keyField="id"
                data={avisAbsence}
                columns={Columns()}
                search
                bootstrap4
              >
                {toolkitProps => (
                  <div>
                    <Col sm="4">
                      <div className="search-box me-2 mb-2 d-inline-block">
                        <div className="position-relative">
                          <SearchBar {...toolkitProps.searchProps} />
                          <i className="bx bx-search-alt search-icon" />
                        </div>
                      </div>
                    </Col>
                    <BootstrapTable
                      wrapperClasses="table-responsive"
                      noDataIndication={() => <NoDataIndication />}
                      striped={false}
                      bordered={false}
                      classes={"table align-middle table-nowrap"}
                      headerWrapperClasses={"table-light"}
                      hover
                      pagination={paginationFactory(pageOptions)}
                      {...toolkitProps.baseProps}
                    />
                  </div>
                )}
              </ToolkitProvider>
            </Col>
          </Row>
        ) : (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              {" "}
              <Spinner type="grow" className="ms-6" color="primary" />
            </div>
            <h4
              style={{ textAlign: "center", marginTop: "2%" }}
              className="ms-6"
            >
              {" "}
              {props.t("Chargement en cours...")}
            </h4>
          </div>
        )}
      </div>

      <Modal isOpen={modal} toggle={toggle} centered={true}>
        <div
          className="modal-header"
          style={{
            width: "100% !important",
            justifyContent: "center !important",
            margin: "0 auto",
            fontSize: "17px",
          }}
          toggle={toggle}
        >
          {props.t("Validation d'avis d'absence")}
        </div>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p> {props.t("Êtes-Vous sûr de valider cet avis d'absence ?")}</p>
            </div>
            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded "
                  onClick={toggleDelete}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  {props.t("Valider")}
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggleRefus}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  {props.t("Refusée")}
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={modalAffiche} toggle={toggleAffiche} centered={true}>
        <div
          className="modal-header"
          style={{
            width: "100% !important",
            justifyContent: "center !important",
            margin: "0 auto",
            fontSize: "17px",
          }}
          toggle={toggleAffiche}
        >
          {props.t(
            "Envoyer une notification aux étudiants au avis d'absence."
          )}
        </div>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>
                {" "}
                {props.t(
                  "Êtes-Vous sûr d'envoyer une notification aux étudiants au avis d'absence ?"
                )}
              </p>
            </div>
            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              {uploadPercent <= 0 && (
                <div>
                  <Button
                    color="info"
                    className="btn-rounded"
                    onClick={toggleNotifier}
                  >
                    <i
                      style={{ color: "white" }}
                      className="far fa-thumbs-up"
                    ></i>
                    {props.t("Notifier")}
                  </Button>
                </div>
              )}

              {uploadPercent > 0 && uploadPercent < 100 && (
                <Progress
                  striped
                  className="progress-xl"
                  color="success"
                  value={uploadPercent}
                >
                  {uploadPercent}%
                </Progress>
              )}

              {uploadPercent === 100 && (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  Success
                  <i
                    style={{
                      paddingLeft: "5px",
                      color: "darkcyan",
                      paddingTop: "3.5px",
                    }}
                    className="fas fa-check me-1"
                  />
                </div>
              )}


              <div>
                <Button
                  onClick={toggleAffiche}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  {props.t("Annuler")}
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={modalDelete} toggle={toggleDeleteAvis} centered={true}>
        <div
          className="modal-header"
          style={{
            width: "100% !important",
            justifyContent: "center !important",
            margin: "0 auto",
            fontSize: "17px"
          }}
          toggle={toggleDeleteAvis}
        >
          {props.t("Suppression avis d'absence")}
        </div>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px"
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>
                {" "}
                {props.t(
                  "Êtes-Vous sûr de vouloir supprimer cet avis d'absence ?"
                )}
              </p>
            </div>
            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px"
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded "
                  onClick={toggleDeleteAvsAbsence}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  {props.t("Oui")}
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggleDeleteAvis}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  {props.t("Non")}
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  )
}

export default withRouter(withTranslation()(DataTableAvisAbsenceValidation))
DataTableAvisAbsenceValidation.propTypes = {
  avisAbsence: PropTypes.array,
  history: PropTypes.object,
  t: PropTypes.any,
}
